// CustomerProfile.js
import React, { useEffect, useState } from 'react';
import CustomerDetails from './Composite/CustomerDetails';
import { Link, useParams } from 'react-router-dom';
import BreadCrumb from '../BreadCrumb';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import logger from '../../utils/logger';

const pages = [
  { name: 'Customer Care', to: '/customers', component: Link, current: false },
  { name: 'Customer Profile', to: '/customers/profile', component: Link, current: true },
];

const CustomerProfile = () => {
  const { id } = useParams(); 
  const [customer, setCustomer] = useState(null);

  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        const customerRef = doc(db, 'customers', id);
        const customerSnap = await getDoc(customerRef);

        if (customerSnap.exists()) {
          setCustomer({ id: customerSnap.id, ...customerSnap.data() });
        } else {
          logger.warn('No such customer!');
        }
      } catch (error) {
        logger.error('Error fetching customer:', error);
      }
    };

    fetchCustomer();
  }, [id]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      <BreadCrumb pages={pages} />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {customer ? (
          <>
            {/* Page Header */}
            <div className="mb-8">
              <div className="flex items-center justify-between">
                <div>
                  <h1 className="text-3xl font-bold text-gray-900 mb-2">
                    Customer Profile
                  </h1>
                  <p className="text-gray-600">
                    Comprehensive view of customer information, vehicles, and history
                  </p>
                </div>
                <div className="hidden sm:block w-16 h-16 bg-gradient-to-br from-indigo-500 to-blue-600 rounded-2xl flex items-center justify-center shadow-lg">
                  <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
              </div>
            </div>

            <CustomerDetails customer={customer} />
          </>
        ) : (
          <div className="bg-white rounded-2xl shadow-lg p-12">
            <div className="flex flex-col items-center justify-center">
              <div className="relative">
                <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-indigo-600"></div>
                <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-blue-400 rounded-full animate-ping opacity-30"></div>
              </div>
              <p className="mt-6 text-lg font-medium text-gray-700">Loading customer profile...</p>
              <p className="mt-2 text-sm text-gray-500">Please wait while we fetch the details</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerProfile;
